import { HowItWorksStep } from '../types/landing';

export const howItWorksSteps: HowItWorksStep[] = [
  {
    number: '1',
    title: 'Collects the signal from your feed',
    bullets: [
      'Reads every post from accounts you follow.',
      'Filters out memes, complaints, and anything without substance.',
      'Searches X and the web for posts about your topics.',
    ],
  },
  {
    number: '2',
    title: 'Gathers context to understand the bigger picture',
    bullets: [
      'Surfaces multiple viewpoints from across the platform, not just your echo chamber.',
      'Tracks emerging narratives and discussions shaping today\'s conversation.',
      'Discovers important posts you might have missed in the noise.',
    ],
  },
  {
    number: '3',
    title: 'Thinks critically',
    bullets: [
      'Synthesizes scattered information from multiple sources into coherent stories.',
      'Prioritizes content based on relevance to your stated interests and goals.',
      'Provides citations and links so you can verify and explore further.',
    ],
  },
  {
    number: '4',
    title: 'Writes your custom digest',
    bullets: [
      'Executive summary of what matters today.',
      'Top stories with full original posts, analysis, and links to related posts and articles.',
      'Motivational content and reflection questions connecting news to your goals.',
    ],
  },
  {
    number: '5',
    title: 'Delivers to your inbox',
    bullets: [
      'Daily, 3x/week, or weekly — your choice.',
      'Reply to any digest to give feedback.',
      'Your algorithm learns and adapts based on what you tell it.',
    ],
  },
];
